<template>
  <validate ref="validator" :validated-value="value" :validations="validations" v-on="$listeners">
    <div class="birth-date q-gutter-sm">
      <birth-date-input ref="year"
                        :value="year"
                        :maxlength="4"
                        class="year"
                        label="שנה"
                        :tabindex="tabIndexSeed + 3"
                        @input="setYear" />
      <birth-date-input ref="month"
                        :value="month"
                        :maxlength="2"
                        label="חודש"
                        class="month"
                        :tabindex="tabIndexSeed + 2"
                        @input="setMonth" />
      <birth-date-input :value="day"
                        :maxlength="2"
                        label="יום"
                        class="day"
                        :autofocus="autofocus"
                        :tabindex="tabIndexSeed + 1"
                        @input="setDay" />

    </div>
  </validate>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import BirthDateInput from '@/components/base/BirthDateInput';
import Validate from '@/components/helpers/Validate';

export default {
  name: 'BirthDate',
  components: { Validate, BirthDateInput },
  created() {
    if (this.value) {
      this.initFields(this.value);
    }
  },
  props: {
    value: String,
    validations: {
      type: String,
      default: 'required|notFuture|dateExists',
    },
    autofocus: Boolean,
    tabIndexSeed: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dirty: false,
      day: null,
      month: null,
      year: null,
    };
  },
  methods: {
    setDay(day) {
      this.markDirty();
      this.day = day;
      if (day.length === 2) {
        this.$refs.month.focus();
      }
      this.setDate();
    },
    setMonth(month) {
      this.markDirty();
      this.month = month;
      if (month.length === 2) {
        this.$refs.year.focus();
      }
      this.setDate();
    },
    setYear(year) {
      this.markDirty();
      this.year = year;
      this.setDate();
    },
    setDate() {
      const formattedDateString = `${this.padIfNecessary(this.day)}-${this.padIfNecessary(this.month)}-${this.year}`;
      const parsedDate = dayjs(formattedDateString, 'DD-MM-YYYY');
      if (parsedDate.isValid()) {
        this.$emit('input', formattedDateString);
      } else {
        this.$emit('input', undefined);
      }
    },
    emitBlur() {
      this.setDate();
      this.$emit('blur');
    },
    initFields(value) {
      const [day, month, year] = value.split('-');
      this.day = day;
      this.month = month;
      this.year = year;
    },
    markDirty() {
      this.dirty = true;
      this.$refs.validator.reset();
    },
    padIfNecessary(value) {
      if (!_.isEmpty(value) && value.length === 1) {
        return `0${value}`;
      }
      return value;
    },
  },
  watch: {
    value(oldValue, newValue) {
      const value = oldValue || newValue;
      if (value && !this.dirty) {
        this.initFields(value);
      }
    },
  },
};
</script>

<style scoped lang="scss">

.birth-date {
  display: flex;
  flex-direction: row;

  .day {
    flex-basis: 20%;
    flex-grow: 1;
  }

  .month {
    flex-basis: 20%;
    flex-grow: 1;
  }

  .year {
    flex-basis: 40%;
    flex-grow: 2;
  }

}

</style>
